<template>
  <div class="dropdown dropdown-list-toggle show" :class="{ show: show }">
    <a
      @click="toggle"
      href="#"
      data-toggle="dropdown"
      class="nav-link notification-toggle nav-link-lg"
      :class="{ beep: notify.length > 0 }"
      ><font-awesome-icon icon="bell" color="white"
    /></a>
    <div
      class="dropdown-menu dropdown-list dropdown-menu-right"
      :class="{ show: show }"
    >
      <div class="dropdown-header">
        Notifications
        <div class="float-right">
          <b-dropdown variant="link" toggle-class="text-decoration-none">
            <template #button-content> {{ filterType }} </template>
            <b-dropdown-item @click="filterNotification('all')"
              >All Notifications</b-dropdown-item
            >
            <b-dropdown-item @click="filterNotification('MARGIN_CALL')"
              >Margin Call</b-dropdown-item
            >
            <b-dropdown-item @click="filterNotification('LOW_EQUITY')"
              >Low Equity</b-dropdown-item
            >
            <b-dropdown-item @click="filterNotification('STOP_OUT')"
              >Stop Out</b-dropdown-item
            >
            <b-dropdown-item @click="filterNotification('FPLB')"
              >FPL/%</b-dropdown-item
            >
          </b-dropdown>
          <!-- <a href="#" @click="markAll">All Notifications</a> -->
        </div>
      </div>
      <div class="dropdown-list-content dropdown-list-icons show">
        <a
          href="#"
          class="dropdown-item dropdown-item-unread"
          v-for="n in notify"
          :key="n.id"
        >
          <div
            class="dropdown-item-icon text-white"
            :class="{
              'bg-danger': n.notify_type == 'MARGIN_CALL',
              'bg-success': n.notify_type == 'STOP_OUT',
              'bg-warning': n.notify_type == 'LOW_EQUITY',
              'bg-primary': n.notify_type == 'FPLB',
            }"
          >
            <font-awesome-icon icon="bell" color="white" />
          </div>
          <div class="dropdown-item-desc">
            {{ n.message }}
            <div class="time text-primary">
              {{ n.created_at | ago }}
            </div>
          </div>
        </a>
      </div>
      <div class="dropdown-footer text-center">
        <!-- <a href="#">View All <i class="fas fa-chevron-right"></i></a> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { getNotify, markAllNotification } from "../../api/notify"

export default {
  data() {
    return {
      show: false,
      notify: [],
      filter: 'all'
    }
  },
  filters: {
    ago: function (date) {
      return moment(date).fromNow();
    }
  },
  methods: {
    toggle() {

      this.show = !this.show
    },
    markAll() {
      this.notify = []
      markAllNotification().then(() => null)
    },
    getClass(c) {
      switch (c) {
        case 'MARGIN_CALL':
          return
          break;

        default:
          break;
      }
    },
    filterNotification(filter) {
      this.filter = filter;
      this.fetchData();
    },
    fetchData() {
      getNotify({
        notify_type: this.filter
      }).then(notify => this.notify = notify.data)
    }
  },
  mounted() {
    // Get Notifications
    this.fetchData();
  },
  computed: {
     ...mapGetters(['role']),
    filterType() {
      switch (this.filter) {
        case 'all':
          return 'All Notifications'
          break;
        case 'MARGIN_CALL':
          return 'Margin Call'
          break;
        case 'STOP_OUT':
          return 'Stop Out'
          break;
        case 'LOW_EQUITY':
          return 'Low Equity'
          break;

        default:
          break;
      }
    }
  }
}
</script>
